export default __webpack_public_path__ + "static/media/closet5-before2-1440w.fe3a43a5.png";